import React from "react";
import Spinner from "react-bootstrap/Spinner";

const AnalyzingLoader: React.FC<{ analysisStatus: string }> = ({
  analysisStatus
}) => (
  <span className="d-flex align-items-center">
    <Spinner
      animation="border"
      size="sm"
      variant="secondary"
      className="me-5"
    />
    <b>{analysisStatus}</b>
  </span>
);
export default AnalyzingLoader;
